module.exports = __webpack_public_path__ + "static/img/successAnLi.6d118c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/successAnLi.png
// module id = VtnG
// module chunks = 2